import React from 'react';
import {
  DisplayLineItem,
  FlexBox,
  TextDense,
  TextH2
} from '@directsoftware/ui-kit-web-admin';
import ReactI18n from 'react-i18n';
import { useSelector } from 'react-redux';
import { formatCurrency } from '../../../shared/helpers';
import { balanceDueWhen, guestBalance } from '../../utils/payment-terms';

const RemainingTotal = ({
  priceTotal,
  pricePaid,
  balanceDueDate,
  balanceDueOn
}) => {
  const brand = useSelector(state => state.brand);
  const translate = ReactI18n.getIntlMessage;

  const { remaining, overpaid } = guestBalance({
    price_total: priceTotal,
    price_paid: pricePaid
  });
  const dueWhen = balanceDueWhen(
    balanceDueOn,
    balanceDueDate,
    brand.date_format,
    translate
  );

  return (
    <>
      <FlexBox justifyContent="space-between">
        <TextH2>{translate(`cx.global.remaining`)}</TextH2>
        <FlexBox flexDirection="column" alignItems="flex-end">
          <TextH2>{formatCurrency(remaining, brand.currency)}</TextH2>
          {remaining > 0 && dueWhen && (
            <TextDense textColor="light-gray">
              {translate(`cx.global.balance_due_date`, {
                date: dueWhen
              })}
            </TextDense>
          )}
        </FlexBox>
      </FlexBox>
      {overpaid > 0 && (
        <DisplayLineItem
          label={translate(`cx.global.overpaid`)}
          value={formatCurrency(overpaid, brand.currency)}
          collapseOnMobile={false}
          removeBottomBorder
          padding="xxs"
        />
      )}
    </>
  );
};

export default RemainingTotal;
